
import { VacationCard } from "../VacationCard";
import { VacationCardSkeleton } from "../VacationCardSkeleton";
import { User } from "@supabase/supabase-js";

interface DealsGridProps {
  vacations: any[];
  loading: boolean;
  user?: User | null;
  favorites?: number[];
  onFavoriteChange?: () => void;
}

export const DealsGrid = ({ 
  vacations, 
  loading, 
  user = null, 
  favorites = [], 
  onFavoriteChange = () => {} 
}: DealsGridProps) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 9 }).map((_, index) => (
          <VacationCardSkeleton key={`skeleton-${index}`} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {vacations.map((vacation) => (
        <VacationCard
          key={vacation['product ID']}
          vacation={vacation}
          user={user}
          isFavorite={favorites.includes(vacation['product ID'])}
          onFavoriteChange={onFavoriteChange}
        />
      ))}
    </div>
  );
};
